import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  mode: 'history',
  base: '/v2',
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: ()=> import('@/views/Index.vue'),
    },
    {
      path: '/recommend-list',
      name: 'RecommendList',
      component: ()=> import('@/views/RecommendList.vue'),
    },
    {
      path: '/list',
      name: 'List',
      component: ()=> import('@/views/List.vue'),
    },
    {
      path: '/dati',
      name: 'Dati',
      component: ()=> import('@/views/dati/Dati.vue'),
    },
    {
      path: '/lianxi',
      name: 'Lianxi',
      component: ()=> import('@/views/dati/Lianxi.vue'),
    },
    {
      path: '/professionList',
      name: 'ProfessionList',
      component: ()=> import('@/views/dati/ProfessionList.vue'),
    },
    {
      path: '/course/:courseId',
      name: 'CourseDetail',
      component: ()=> import('@/views/CourseDetail.vue'),
    },
    {
      path: '/coupon',
      name: 'Coupon',
      component: ()=> import('@/views/Coupon.vue'),
    },
    {
      path: '/share-card',
      name: 'ShareCard',
      component: ()=> import('@/views/ShareCard.vue'),
    },
    {
      path: '/coupon-course-list',
      name: 'CouponCourseList',
      component: ()=> import('@/views/CouponCourseList.vue'),
    },

    //个人中心
    {
      path: '/user/detail',
      name: 'UserDetail',
      component: ()=> import('@/views/user/UserDetail.vue'),
    },
    {
      path: '/user/edit',
      name: 'UserEdit',
      component: ()=> import('@/views/user/UserEdit.vue'),
    },
    {
      path: '/user/trans',
      name: 'UserTrans',
      component: ()=> import('@/views/user/UserTrans.vue'),
    },
    {
      path: '/user/datiRecordList',
      name: 'UserTrans',
      component: ()=> import('@/views/user/UserDatiRecord.vue'),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js